import { render, staticRenderFns } from "./PublicationController.vue?vue&type=template&id=f8fad5fe&scoped=true&"
import script from "./PublicationController.vue?vue&type=script&lang=js&"
export * from "./PublicationController.vue?vue&type=script&lang=js&"
import style0 from "./PublicationController.vue?vue&type=style&index=0&id=f8fad5fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8fad5fe",
  null
  
)

export default component.exports